import { render, staticRenderFns } from "./OzInput.vue?vue&type=template&id=333c3b70&scoped=true&"
import script from "./OzInput.vue?vue&type=script&lang=ts&"
export * from "./OzInput.vue?vue&type=script&lang=ts&"
import style0 from "./OzInput.vue?vue&type=style&index=0&id=333c3b70&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333c3b70",
  null
  
)

/* custom blocks */
import block0 from "./OzInput.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports